import { getCountry } from "react-native-localize";

export const deviceCountryIsoCode = getCountry();
